 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.core-js","19":"npm.create-react-class","20":"npm.d3-scale","21":"npm.dompurify","22":"npm.react-querybuilder","23":"npm.react-smooth","24":"npm.react-sortable-hoc","25":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"a2aa61b09e52766619ba","5":"40557038fff9a93bd892","6":"b60353fe52070d422928","7":"6d3ad3a1eaa54d06bf6c","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"f8c245d91551c989408d","14":"1b625f3378a9db60bbef","17":"d2a7ae28e5ef57d500ca","18":"aeda64833536ef365e2a","19":"df2336024ddc5dc39567","20":"53276394962f6600858a","21":"4753773ccd4f3f64929c","22":"aea9a033bfa0e2e2ff81","23":"60be86c4cd67c3937270","24":"754bb30c4f2a452a4882","25":"9df6564a3d733b74319f","27":"2ca668015f436f1779c4","28":"56b66982e4755fd4cd7e","29":"b3f07f0267a7adc146ef","30":"19061617d0dd30bbf8dc","31":"ed39db49b32a14d087ed","32":"1a2d5a81f46eb4b9b439","33":"fa84b1d7829fbc54f122","34":"ca8e0991d42edb625335","35":"0d6dc85b67c7ca912f92","36":"0895a6e622fa4176bdc7","37":"615e669198cb3aff78a2","38":"3fd8daa992fad78382e3","39":"eb2b07ccd0ccabcba8f6","40":"2d3bdd33646f527c1c12","41":"1e87482771fe28c00f17","42":"9292aa8c695f3b697d08","43":"35269af4ae21e7455b95","44":"33d509b85caf2937f428","45":"b9a93bcd994ccbf8aae3","46":"772ba9b5c9d50df3ace2","47":"555332e69fd4b2855872","48":"7d4cd1a13491bb04b858","49":"d164ce39e925f366594f","50":"8025c9352d65a88a38c3","51":"e10ddfb4172c53c78417","52":"3364f242795f7cf0a950","53":"38a1c05db13251e0be90","54":"eeb214449e85e5e0dc7c","55":"d69da9d6ad4b9d1e627a","56":"ab2a484822858db98e57","57":"f723ba46fb640282138e","58":"213018aceeb0b91d22de","59":"6881a6d239913f2eb83d","60":"4d021e9fb1d7e91cd9f1","61":"0b163addb139d6a318a2","62":"993f4699de2f899e9fd9","63":"6ab5b8215e8478f11279","64":"4eeaf78baa68a5a3b532","65":"bc37186a6da401e586d7","66":"addc6a9ea93d76922872","67":"7c3dc52e3654b7a72851","68":"213397164100efb71788","69":"8db55049c1d7a2df52c5","70":"f7570b2e93261d44f226","71":"4c1587bca142c3a3f5c9","72":"d85178319992edd9d10c","73":"6dc3678a6249f332d782","74":"5c5ee20582863446040c","75":"cfc8fc285718b6cc35fb","76":"cc11a5ad704869f1b9bc","77":"e26b9331ca2dd0cd822d","78":"aa40a2ef160500f80451","79":"bb4ec9daf16546ddd8dc","80":"7f8c0a48018a12740b0e","81":"4600eab7aa9e03033d2f","82":"65b4f667d062d05209f6","83":"97afb22f286734779ee1","84":"efd413635fe2351dacee","85":"0848051414703532b442","86":"c903f2904567c0fe9606","87":"fabd1bbede2378e2d099","88":"e5ed9bdebbff69d880c9","89":"78c53f1a69090ecde334","90":"0444e999250349697c3b","91":"fad4aa28d9094505dfb5","92":"1106f00c383df47214f8","93":"981013429c1eac1b4d99"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/c30e33c/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
